(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const searchButtons = document.querySelectorAll('[href="#search"]');
    const modal = document.getElementById("search-modal");
    const closeModalButton = document.getElementById("close-modal");
    const modalSearchInput = document.getElementById("modal-search-input");
    const modalSearchResults = document.getElementById("modal-search-results");
    const clearSearchButton = document.getElementById("clear-search");
  
    // Open modal with animation
    for (const i of searchButtons) {
      i.addEventListener('click', (e) => {
        e.preventDefault()
        modal.classList.remove("hidden", "modal-close");
        modal.classList.add("modal-open");
        modalSearchInput.focus();
      })
    }
  
    // Close modal with animation
    function closeModal() {
      modal.classList.remove("modal-open");
      modal.classList.add("modal-close");
  
      // Delay to ensure animation completes before hiding
      setTimeout(() => {
        modal.classList.add("hidden");
        modalSearchResults.innerHTML = "";  // Clear results when closing
      }, 300); // Match this delay to `duration-300`
    }
  
    closeModalButton.addEventListener("click", closeModal);
    window.addEventListener("click", (event) => {
      if (event.target === modal) {
        closeModal();
      }
    });
  
    // Clear search input and results on clear button click
    clearSearchButton.addEventListener("click", () => {
      modalSearchInput.value = "";
      modalSearchResults.innerHTML = "";
      modalSearchInput.focus();
    });
  
    // Listen to input in the search box
    modalSearchInput.addEventListener("input", async function() {
      const query = modalSearchInput.value.trim();
  
      // Clear results if the query is empty
      if (query === "") {
        modalSearchResults.innerHTML = "";
        return;
      }
  
      try {
        // Fetch search suggestions from Shopify
        const response = await fetch(`/search/suggest.json?q=${query}`);
        const data = await response.json();
        
        // Display search results
        displaySearchResults(data.resources.results);
      } catch (error) {
        console.error("Error fetching search results:", error);
      }
    });
  
    function displaySearchResults(results) {
      modalSearchResults.innerHTML = ""; // Clear previous results
  
      // Handle case with no results
      if (!results.products.length && !results.pages.length && !results.articles.length && !results.collections.length) {
        modalSearchResults.innerHTML = "<p class='text-gray-600'>No results found</p>";
        return;
      }
  
      // Build HTML for search results
      let resultsContent = "";
  
      if (results.products.length) {
        results.products.forEach(product => {
          resultsContent += `
            <div class="p-3 border-b border-gray-200 flex items-center">
              <a href="${product.url}" class="flex items-center w-full hover:bg-gray-100 p-2 rounded">
                <img src="${product.featured_image.url}" alt="${product.title}" class="w-12 h-12 rounded mr-3">
                <div>
                  <h4 class="text-sm font-semibold text-gray-800">${product.title}</h4>
                  <p class="text-xs text-gray-500">${product.price}</p>
                </div>
              </a>
            </div>
          `;
        });
      }
  
      modalSearchResults.innerHTML = resultsContent; // Insert results into modal
    }
  });
  } catch(e) { console.error(e); }
})();

})();
